// extracted by mini-css-extract-plugin
export default {"option":"styles_option__qcEcO","focused":"styles_focused__scsJ6","selected":"styles_selected__RcsrH"};